// extracted by mini-css-extract-plugin
export default {"title":"Zaa-z","warning":"_aa-z","sizeOptionsLegendText":"aba-z"};